module.exports = __webpack_public_path__ + "static/media/album-collection.29a4c85e.svg";